import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';

import FaqSection from '@rover/components/src/FaqSection';
import LandingFaqList from '@rover/react-lib/src/pages/landing/components/LandingFaq/LandingFaqList';
import { useApiSeoLocationByPathFaqsList } from '@rover/rsdk/src/apiClient/latest/api-seo-location-by-path-faqs-list';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';

interface SeoLocationFaqListProps {
  titleCasedServiceKeyword: string;
  locationName: string;
}

const SeoLocationFaqList: FC<SeoLocationFaqListProps> = ({
  titleCasedServiceKeyword,
  locationName,
}) => {
  const { pathname } = useLocation();
  const { data: faqs } = useApiSeoLocationByPathFaqsList({ path: pathname });

  if (!faqs || faqs.length === 0) return null;
  const brandDisplayName = getBrandDisplayName();

  return (
    <LandingFaqList faqs={faqs} mt="16x" mb="8x">
      <FaqSection.Header variant="heading" webProps={{ responsive: false }}>
        <Trans>
          FAQs for {titleCasedServiceKeyword} - {locationName}
        </Trans>
      </FaqSection.Header>
      <FaqSection.Subheader>
        <Trans>Frequently asked questions about {brandDisplayName}</Trans>
      </FaqSection.Subheader>
    </LandingFaqList>
  );
};

export default SeoLocationFaqList;
